module.exports = __webpack_public_path__ + "static/media/slider1-element.7e63ede6.png";